import { TAssetType } from 'src/typings/base-types';

export function findIfPrintDeviceProfile(deviceType: TAssetType): boolean {
  return !['Storage', 'CommercialProducer', 'MarketMaker', 'InfiniteBus'].includes(deviceType);
}

export function findIfShowChartFour(deviceType: TAssetType): boolean {
  return ['MarketMaker', 'InfiniteBus'].includes(deviceType);
}
